import { useTranslation } from "react-i18next";
import { useGetMyWorkerLeaveReportQuery } from "../api/workContractApiSlice";
import { useEffect } from "react";

export default function MyLeaveHoursLeft(
    {
        forceRefresh = false
    }
) {

    const [t] = useTranslation(["global", "absenceReport"])

    const  {
        data: leaveReport,
        isSuccess,
        isError,
        isLoading,
        isFetching,
        error,
        refetch
    } = useGetMyWorkerLeaveReportQuery()

    useEffect(() => {
        if (forceRefresh) {
            refetch()
        }
    }, [forceRefresh])

    function getColor(value) {
        if (value > 0) {
            return "text-accent"
        } else return "text-danger"

    }

    let content;

    if (isSuccess) {
        content = (
            <div className="card bg-dark mb-4">
                <div className="card-body text-center">
                    <div className="row">
                        <div className="col">
                            <span >{t("absenceReport:property.available_leave_time")}</span>
                            <br />
                            <h4 className="my-3"><b className={getColor(leaveReport.holidays.available)}>{Math.round(leaveReport.holidays.available*100)/100}</b> {t("unit.hours")} <i className="fa-solid fa-umbrella-beach"></i> </h4>
                            <span className=" text-muted">Contabile  {leaveReport.holidays.balance}</span>
                        </div>
                        <div className="col">
                        <span>Permessi disponibili</span>
                            <br />
                            <h4 className="my-3"><b className={getColor(leaveReport.timeOff.available + leaveReport.abolished.available )}>{Math.round(leaveReport.timeOff.available*100 + leaveReport.abolished.available*100)/100}</b> {t("unit.hours")} <i className="fa-regular fa-clock"></i></h4>
                            <span className=" text-muted">Contabile  {leaveReport.timeOff.available + leaveReport.abolished.available}</span>
                        </div>
                    </div>


                </div>

            </div>

        )
    }

    return content

}